module.exports = __webpack_public_path__ + "img/IMG_0380.2039d547.png";